'use strict'

var merge = require('./lib/util/merge')
var xlink = require('./lib/xlink')
var xml = require('./lib/xml')
var xmlns = require('./lib/xmlns')
var aria = require('./lib/aria')
var svg = require('./lib/svg')

module.exports = merge([xml, xlink, xmlns, aria, svg])



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/svg.js
// module id = 882
// module chunks = 35783957827783 241767136424496